import React from "react";
import {BrowserRouter, useHistory} from "react-router-dom";
import {NavigateToOptions} from "./types";
import {NavigatorProvider} from "./NavigatorProvider";

type NavigateToHandler =
	(history: ReturnType<typeof useHistory>) => (path: string, options: NavigateToOptions | undefined) => void

export function RouterWithNavigatorProvider({children, getUserConfirmation, getNavigateTo}: {
	children: React.ReactNode,
	getUserConfirmation?: ((message: string, callback: (ok: boolean) => void) => void) | undefined,
	getNavigateTo: NavigateToHandler
}) {
	return (
		// V1 is the default app at / during the beta opt-in rollout (PFS-10283 — see
		// Dockerfile for the revert note), so the router needs the matching basename.
		// PUBLIC_URL is set by CRA from package.json's "homepage" field at build time;
		// empty in dev, where V1's dev server still serves itself at the root.
		<BrowserRouter basename={process.env.PUBLIC_URL} getUserConfirmation={getUserConfirmation}>
			<NavigatorProviderWrapper getNavigateTo={getNavigateTo}>
				{children}
			</NavigatorProviderWrapper>
		</BrowserRouter>
	)
}

function NavigatorProviderWrapper({children, getNavigateTo}: {
	children: React.ReactNode,
	getNavigateTo: NavigateToHandler
}) {
	const history = useHistory();
	return (
		<NavigatorProvider navigateTo={getNavigateTo(history)}>
			{children}
		</NavigatorProvider>
	)
}